"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Text_1 = __importDefault(require("../Text"));
var Box_1 = __importDefault(require("../Box"));
var Link_1 = __importDefault(require("../Link"));
var Image_1 = __importDefault(require("../Image"));
var YEAR = new Date().getFullYear();
function CopyRight(props) {
    var _a, _b;
    var copyright = props.copyright, rest = __rest(props, ["copyright"]);
    return (react_1.default.createElement(Container, __assign({}, rest),
        react_1.default.createElement(CopyRightText, null, (_a = copyright === null || copyright === void 0 ? void 0 : copyright.text) === null || _a === void 0 ? void 0 : _a.replace('{year}', YEAR.toString())),
        (copyright === null || copyright === void 0 ? void 0 : copyright.moreLinks) &&
            react_1.default.createElement(MoreLinksContainer, null,
                (copyright === null || copyright === void 0 ? void 0 : copyright.link_url) &&
                    react_1.default.createElement(MoreLink, { href: copyright.link_url },
                        (copyright === null || copyright === void 0 ? void 0 : copyright.icon_url) && react_1.default.createElement(Image_1.default, { src: copyright.icon_url, alt: 'link' }), copyright === null || copyright === void 0 ? void 0 :
                        copyright.link_text), (_b = copyright === null || copyright === void 0 ? void 0 : copyright.moreLinks) === null || _b === void 0 ? void 0 :
                _b.map(function (_a) {
                    var _b = _a.url, url = _b === void 0 ? '' : _b, _c = _a.text, text = _c === void 0 ? '' : _c, icon_url = _a.icon_url;
                    return (react_1.default.createElement(MoreLink, { key: "" + url + text, href: url },
                        icon_url && react_1.default.createElement(Image_1.default, { src: icon_url, alt: 'link' }),
                        text));
                }))));
}
var Container = (0, styled_1.default)(Text_1.default)({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
});
var CopyRightText = (0, styled_1.default)(Text_1.default)({
    color: 'rgba(255, 255, 255, 0.8)',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '26px',
    textAlign: 'center'
});
var MoreLinksContainer = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        _b[theme.mediaQueries.md] = {
            flexDirection: 'row',
            position: 'absolute',
            top: '100%',
        },
        _b);
});
var MoreLink = (0, styled_1.default)(Link_1.default)({
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    color: 'rgba(255, 255, 255, 0.8)',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '26px',
    textAlign: 'center'
});
exports.default = CopyRight;
